import { List, ListItemButton, ListItemText } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import type { IMenuItem } from './types';

interface Props {
  menu: (IMenuItem & { isActive: boolean })[];
}

export const SidebarMenu = ({ menu }: Props) => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <List sx={{ px: 2 }}>
      {menu.map((item) => (
        <ListItemButton
          key={item.text}
          onClick={() => navigate(`${item.link}${location.search}`)}
          sx={{
            borderRadius: '10px',
            mb: 1,
            backgroundColor: item.isActive ? '#E6F4F1' : 'transparent',
            color: item.isActive ? '#0F766E' : '#374151',
            '&:hover': {
              backgroundColor: '#E6F4F1',
            },
          }}
        >
          <ListItemText primary={item.text} />
        </ListItemButton>
      ))}
    </List>
  );
};
